// extracted by mini-css-extract-plugin
module.exports = {"price":"banner_price_OXgXx"};